export const WATCHLIST_SECTIONS = Object.freeze([
  { key: "Stocks", assetType: "stocks" },
  { key: "Cryptos", assetType: "cryptos" },
  { key: "ForexPairs", assetType: "forex" },
  { key: "Indices", assetType: "indices" },
  { key: "Commodities", assetType: "commodities" },
  { key: "Futures", assetType: "futures" },
]);

export const WATCHLIST_SECTION_KEYS = WATCHLIST_SECTIONS.map(({ key }) => key);

const rowName = (row) => String(row?.name || "");

const rowKey = (row) => {
  if (row?.id != null && row.id !== "") return String(row.id);
  return `${row?.assetType || "unknown"}:${row?.ticker || rowName(row)}`;
};

export const groupWatchlistRows = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  return Object.fromEntries(
    WATCHLIST_SECTIONS.map(({ key, assetType }) => [
      key,
      list
        .filter((row) => row?.assetType === assetType)
        .sort((left, right) => rowName(left).localeCompare(rowName(right))),
    ]),
  );
};

export const mergeGroupedWatchlistRows = (previous, rows) => {
  const byId = new Map();

  WATCHLIST_SECTION_KEYS.forEach((section) => {
    (Array.isArray(previous?.[section]) ? previous[section] : []).forEach((row) => {
      byId.set(rowKey(row), row);
    });
  });

  (Array.isArray(rows) ? rows : []).forEach((row) => {
    const key = rowKey(row);
    byId.set(key, { ...byId.get(key), ...row });
  });

  return groupWatchlistRows(Array.from(byId.values()));
};
